import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import { useTranslation } from "react-i18next"

interface PreviousButtonProps {
  onBackClick: () => void
  withText?: boolean
  style?: any
}

const PreviousButton: React.FC<PreviousButtonProps> = ({ onBackClick, withText = true, style }) => {
  const { t } = useTranslation()

  return (
    <div
      onClick={() => onBackClick()}
      style={style}
      className="flex items-center cursor-pointer gap-x-1"
    >
      <FontAwesomeIcon
        style={{ cursor: "pointer" }}
        className="flex-shrink-0 h-5 text-black w-5"
        icon={faArrowLeft}
      />
      {withText && <span className="font-medium text-sm">{t("common.back")}</span>}
    </div>
  )
}

export default PreviousButton
